package club.srams.website.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.css.userSelect
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import kotlin.js.Promise
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun DropdownMenuComponent(
    label: String
    , items: List<String>
    , onItemSelected: (String) -> Unit
    , color: CSSColorValue = Color.white
    , backgroundColor: CSSColorValue = Color("#3d7ebf")
) {
    var keepOpen by remember { mutableStateOf(false) }
    var overMenuItem by remember { mutableStateOf(false) }
    var overDropdown by remember { mutableStateOf(false) }
    var selectedItem by remember { mutableStateOf<String?>(null) }

    val scope = rememberCoroutineScope()
    var closeJob by remember { mutableStateOf<Job?>(null) }

    println("keepOpen: $keepOpen - overMenuItem: $overMenuItem - overDropdown: $overDropdown")

    // Anchor element that triggers the dropdown
    Div(
        attrs = {
            style {
                position(Position.Relative)
                display(DisplayStyle.Initial)
            }
        }
    ) {

        Row(
            modifier = Modifier
                .onClick { keepOpen = !keepOpen }
                .onMouseEnter {
                    closeJob?.cancel()
                    overMenuItem = true
                }
                .onMouseLeave {
                    closeJob = scope.launch {
                        delay(500.milliseconds)
                        overMenuItem = false
                        keepOpen = false
                    }
                }
        ) {
            SpanText(selectedItem ?: label)
            SpanText(if (keepOpen) " ▲" else " ▼")
        }

        // Dropdown panel using Silk Popover
        // Replace the entire Popover block with this:
        val backgroundColor = if (ColorMode.current == ColorMode.LIGHT) Colors.White else Colors.Black
        if (keepOpen || overDropdown || overMenuItem) {
            Div(
                attrs = Modifier
                    .position(Position.Absolute)
                    .top(100.percent)
                    .left(0.px)
                    .margin(top = 4.px)
                    .minWidth(140.px)
                    .backgroundColor(backgroundColor)
                    .borderRadius(6.px)
                    .border(1.px, LineStyle.Solid, Color("#e0e0e0"))
                    .boxShadow(0.px, 4.px, 12.px, color = rgba(0, 0, 0, 0.15))
                    .zIndex(100)
                    .display(DisplayStyle.Flex)
                    .flexDirection(FlexDirection.Column)
                    .padding(4.px, 0.px)
                    .onMouseEnter {
                        closeJob?.cancel()
                        overMenuItem = false
                        overDropdown = true
                    }
                    .onMouseLeave {
                        closeJob = scope.launch {
                            delay(500.milliseconds)
                            overDropdown = false
                            keepOpen = false
                        }
                    }
                    .toAttrs()
            ) {
                items.forEach { item ->
                    DropdownItem(
                        text = item,
                        isSelected = item == selectedItem,
                        onClick = {
                            selectedItem = item
                            keepOpen = false
                            onItemSelected(item)
                        }
                    )
                }
            }
        }
    }
}

@Composable
private fun DropdownItem(
    text: String,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    var isHovered by remember { mutableStateOf(false) }

    val selected = if (ColorMode.current == ColorMode.LIGHT) Color.white else Color.black
    val hovered = if (ColorMode.current == ColorMode.LIGHT) Color.lightgray else Color.darkslategray

    val textColor = if (ColorMode.current == ColorMode.LIGHT) Color.black else Color.ivory
    val textColorSelected = if (ColorMode.current == ColorMode.LIGHT) Color.black else Color.white
    val textColorHovered = if (ColorMode.current == ColorMode.LIGHT) Color.black else Color.white

    Div(
        attrs = {
            onClick { onClick() }
            onMouseEnter { isHovered = true }
            onMouseLeave { isHovered = false }
            style {
                padding(10.px, 16.px)
                cursor("pointer")
                fontSize(14.px)
                color(
                    when {
                        isSelected -> textColorSelected
                        isHovered  -> textColorHovered
                        else       -> textColor
                    }
                )
                //color(if (isSelected) Color("#3d7ebf") else Color("#333"))
                fontWeight(if (isSelected) "bold" else "normal")
                backgroundColor(
                    when {
                        isSelected -> selected
                        isHovered  -> hovered
                        else       -> Color.transparent
                    }
                )
                userSelect(UserSelect.None)
            }
        }
    ) {
        SpanText(text)
    }
}